import { useEffect, useRef, useState } from "react"

export const useIntersectionObserver = (
  options: IntersectionObserverInit = {}
) => {
  const [isVisible, setIsVisible] = useState(false)
  const [hasBeenVisible, setHasBeenVisible] = useState(false)
  const elementRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting
        setIsVisible(visible)

        // Une fois visible, on garde en mémoire pour éviter de perdre les données
        if (visible && !hasBeenVisible) {
          setHasBeenVisible(true)
        }
      },
      {
        threshold: 0.1, // Se déclenche quand 10% de l'élément est visible
        rootMargin: "100px", // Commence à charger 100px avant que l'élément soit visible
        ...options,
      }
    )

    observer.observe(element)

    return () => {
      observer.unobserve(element)
    }
  }, [hasBeenVisible, options])

  return {
    elementRef,
    isVisible,
    hasBeenVisible,
  }
}
